import styled from "styled-components";

export const AlertWrapper = styled.div``

export const MyAlert = styled.div`
    border: 1px solid red;
    background-color: pink;
    padding: 0.5rem;
`